import { render, staticRenderFns } from "./model-consumer.vue?vue&type=template&id=4ff0b246&scoped=true&"
import script from "./model-consumer.vue?vue&type=script&lang=js&"
export * from "./model-consumer.vue?vue&type=script&lang=js&"
import style0 from "./model-consumer.vue?vue&type=style&index=0&id=4ff0b246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff0b246",
  null
  
)

export default component.exports